import React from "react";
import { Input, Select, DatePicker } from 'antd';
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import DynamicList from "components/fields/DynamicList";


const JobPostFields = ({ recordData, mode, ...props }) => {
	
	const { TextArea } = Input;  	
	
  	return (
    	<div className="space-y-4">
			<FormItem
				name="jpo_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<FormItem
				name="jpo_employment_type_id"
				hidden
			>
				<Input type="hidden" value={4}/>
			</FormItem>
			<FormItem
				name="jpo_department_id"
				hidden
			>
				<Input type="hidden" value={0}/>
			</FormItem>
			
			
			<div className="grid grid-cols-1 md:grid-cols-5 lg:grid-cols-6 gap-y-2 gap-x-4 w-full">
				<FormItem className="font-medium mb-2 md:cols-span-2 lg:col-span-3"
					name="jpo_title"
					label="Job Title"
					rules={[requiredField()]}
					value={recordData?.jpo_title}
				>
					{mode === 'edit' &&
						<Input id="jpo_title"
							className="input-field"
							maxLength={100}
							placeholder="Enter job title"
						/>
					}
				</FormItem>
				<FormItem className="font-medium mb-2"
					name="jpo_status_id"
					label="Status"
					rules={[requiredField()]}
					value={recordData?.status_name}
				>
					{mode === 'edit' &&
						<Select id="jpo_status_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.jobPostStatusList}
						/>
					}	                
				</FormItem>
				<FormItem
                    label="Posting Date From"
                    name="jpo_posting_date_from"
                    rules={[requiredField()]}
					value={recordData?.jpo_posting_date_from}
                    >
                        {mode === 'edit' &&
                        <DatePicker
                            showSearch
                            size="large"
							className="input-field"
                        />
                        }
                </FormItem>
				<FormItem
                    label="Posting Date To"
                    name="jpo_posting_date_to"
					value={recordData?.jpo_posting_date_to}
                    >
                        {mode === 'edit' &&
                        <DatePicker
                            showSearch
                            size="large"
							className="input-field"
                        />
						}
                </FormItem>
				<FormItem className="font-medium mb-2 md:col-span-2"
					name="jpo_job_level_id"
					label="Job Level"
					rules={[requiredField()]}
					value={recordData?.level_name}
				>
					{mode === 'edit' &&
						<Select id="jpo_job_level_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.jobPostLevelList}
						/>
					}	                
				</FormItem>
				<FormItem className="font-medium mb-2 md:col-span-2"
					name="jpo_employment_type_id"
					label="Employment Type"
					rules={[requiredField()]}
					value={recordData?.employment_type}
				>
					{mode === 'edit' &&
						<Select id="jpo_employment_type_id"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.employmentTypeList}
						/>
					}	                
				</FormItem>
				<FormItem className="font-medium mb-2 md:col-span-2"
					label="Location"
					name="jpo_location"
					value={recordData?.location_name}
				>
					{mode === 'edit' &&
						<Select id="jpo_location"
							className="input-field"
							showSearch
							allowClear={true}
							options={recordData?.countryList}
						/>
					}
				</FormItem>
			</div>
			<FormItem className="font-medium  mb-2 w-full"
				name="jpo_job_overview"
				label="Job Overview"
				rules={[requiredField()]}
				>
					<TextArea id="jpo_job_overview"
						className="input-field"
						rows={3}
						autoSize
						placeholder="Short summary to display as job preview"
						maxLength={500}
						readOnly={mode === 'view'}
					/>
			</FormItem>
			<FormItem className="font-medium  mb-2 w-full"
				name="jpo_job_description"
				label="Job Description"
				rules={[requiredField()]}
				>
					<TextArea id="jpo_job_description"
						className="input-field"
						rows={3}
						autoSize
						readOnly={mode === 'view'}
					/>
			</FormItem>

			<DynamicList 
				name="jpo_key_responsibilities"
				label="Key Responsibilities"
				placeholder="Enter responsibility"
				addButtonClass="text-gray-500 dark:text-white"
				mode={mode}
   				recordData={recordData}
			/>

			<DynamicList 
				name="jpo_preferred_qualifications"
				label="Preferred Qualifications"
				placeholder="Enter qualification"
				addButtonClass="text-gray-500 dark:text-white"
				mode={mode}
   				recordData={recordData}
			/>

			<FormItem className="font-medium  mb-2 w-full"
				name="jpo_add_info"
				label="Additonal Information"
				>
					<TextArea id="jpo_add_info"
					className="input-field"
					rows={3}
					autoSize
					readOnly={mode === 'view'}
					/>
			</FormItem>

			<FormItem className="font-medium  mb-2 w-full"
				name="jpo_how_to_apply"
				label="How to Apply"
			>
					<TextArea id="jpo_how_to_apply"
						className="input-field"
						rows={3}
						autoSize
						readOnly={mode === 'view'}
					/>
			</FormItem>
					 			
		</div>	 	
  	);
};

export default JobPostFields;
